<form
  [formGroup]="claimTypeForm"
  (ngSubmit)="onSubmit()"
  [hasUnsavedData]="claimTypeForm"
>
  <button type="submit" hidden="hidden"></button>

  <div class="row mb-2">
    <div class="col-6 mr-auto">
      <div class="form-group">
        <label class="form-title-label" for="name" translate
        >CLAIM_TYPE_LBL_NAME</label
        >
        <input
          id="name"
          class="form-control form-title"
          type="text"
          formControlName="name"
          checkFormFieldValidity
          [maxLength]="150"
        />
      </div>
      <div class="col"></div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 col-md-6">
      <div class="form-group row">
        <label class="col-4 col-form-label-sm" for="productCategoryId" translate
        >CLAIM_TYPE_LBL_PRODUCT_CATEGORY</label
        >
        <div class="col">
          <product-category-edit
            [controlForm]="this.claimTypeForm.controls['productCategoryId']"
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-4 col-form-label-sm" for="defaultFeeAmount" translate
        >CLAIM_TYPE_LBL_DEFAULT_FEE</label
        >
        <div class="col">
          <input
            id="defaultFeeAmount"
            name="defaultFeeAmount"
            class="form-control form-control-sm"
            type="text"
            formControlName="defaultFeeAmount"
            checkFormFieldValidity
            [placeholder]="this.amountPlaceholder | translate"
            mask="separator.2"
            [suffix]="this.amountSuffix | translate"
            [showMaskTyped]="false"
            [decimalMarker]="'.'"
            [allowNegativeNumbers]="false"
          />
        </div>
      </div>
    </div>
    <div class="col">

      <!--      <div class="form-group row">-->
      <!--        <label class="col-4 col-form-label-sm" for="sequence" translate-->
      <!--        >CLAIM_TYPE_LBL_SEQUENCE</label-->
      <!--        >-->
      <!--        <div class="col">-->
      <!--          <input-->
      <!--            id="sequence"-->
      <!--            name="sequence"-->
      <!--            class="form-control form-control-sm"-->
      <!--            type="text"-->
      <!--            formControlName="sequence"-->
      <!--            checkFormFieldValidity-->
      <!--            mask="09"-->
      <!--            [showMaskTyped]="false"-->
      <!--            [decimalMarker]="'.'"-->
      <!--            [allowNegativeNumbers]="false"-->
      <!--          />-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="form-group row">
        <label class="col-4 col-form-label-sm" for="active" translate
        >CLAIM_TYPE_LBL_ACTIVE</label
        >
        <div class="col">
          <input
            class="form-control-sm"
            id="active"
            name="active"
            type="checkbox"
            value=""
            formControlName="active"
            checkFormFieldValidity
          />
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-12">
      <div class="d-flex align-items-center mb-2">
        <label class="form-title-label mb-0 me-3" translate
        >CLAIM_TYPE_LBL_DOCUMENTS</label
        >
        <button
          type="button"
          class="btn btn-sm btn-outline-primary"
          (click)="openClaimTypeDocumentsModal()"
          translate
        >
          CLAIM_TYPE_LBL_DOC_MANAGE
        </button>
      </div>

      @if (documentTypes.length > 0) {
        <app-generic-grid
          style="height: 300px"
          [data]="documentTypesValues"
          [tabViewName]="'selectDocumentTypes'"
        />
      } @else {
        <div class="text-muted" translate>CLAIM_TYPE_LBL_DOC_EMPTY</div>
      }
    </div>
  </div>
</form>
